import {
  FileDoneOutlined,
  MoneyCollectOutlined,
  TableOutlined,
  CarryOutOutlined,
} from "@ant-design/icons";
import { Permission, Resource } from "components/CurrentUser/constants";
import BlankLayout from "layouts/BlankLayout";
import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";

const routes: IRouteConfig[] = [
  {
    path: "/crosscheck",
    name: "crosscheck.title",
    icon: CarryOutOutlined,
    component: BlankLayout,
    permissions: [
      [Resource.INVOICE, Permission.FULL_VIEW],
      [Resource.INVOICE, Permission.VIEW],
    ],
    routes: [
      {
        path: "/crosscheck/invoice",
        name: "advertiser.crosscheck.invoice.title",
        icon: FileDoneOutlined,
        component: lazy(() => import("./pages/Invoice")),
        searchable: true,
        exact: true,
        permissions: [
          [Resource.INVOICE, Permission.FULL_VIEW],
          [Resource.INVOICE, Permission.VIEW],
        ],
        placeholderConfig: {
          filter: true,
        },
      },
      {
        path: "/crosscheck/invoice/:id/:tab",
        name: "advertiser.crosscheck.invoice.title",
        component: lazy(() => import("./pages/Invoice/pages/InvoiceDetail")),
        searchable: false,
        hideInMenu: true,
        exact: true,
        permissions: [
          [Resource.INVOICE, Permission.FULL_VIEW],
          [Resource.INVOICE, Permission.VIEW],
          [Resource.PAYMENT, Permission.FULL_VIEW],
          [Resource.PAYMENT, Permission.VIEW],
        ],
      },
      {
        path: "/crosscheck/payment",
        name: "advertiser.crosscheck.payment.title",
        icon: MoneyCollectOutlined,
        component: lazy(() => import("./pages/Payment")),
        searchable: true,
        exact: true,
        permissions: [
          [Resource.PAYMENT, Permission.FULL_VIEW],
          [Resource.PAYMENT, Permission.VIEW],
        ],
        placeholderConfig: {
          filter: true,
        },
      },
      {
        path: "/crosscheck/payment/:id",
        name: "advertiser.crosscheck.payment.title",
        component: lazy(() => import("./pages/Payment/pages/PaymentDetail")),
        exact: true,
        hideInMenu: true,
        permissions: [
          [Resource.PAYMENT, Permission.FULL_VIEW],
          [Resource.PAYMENT, Permission.VIEW],
        ],
      },
      {
        path: "*",
        component: lazy(() => import("components/base/Errors/NotFound")),
        hideInMenu: true,
      },
    ],
  },
];

export default routes;
